import $ from "jquery";
import validate from "jquery-validation";

$.validator.addMethod("digitsandspaces", function(value, element) {
    return this.optional(element) || /^[\d\s\+]+$/i.test(value);
}, "Numbers and spaces only please");

$.validator.addMethod("alphanumeric", function(value, element) {
    return this.optional(element) || /^\w+$/i.test(value);
}, "Letters, numbers, and underscores only please");

$.validator.addMethod("letterswithbasicpunc", function(value, element) {
    return this.optional(element) || /^[0-9a-z\-.,()'"!&£$%@\s]+$/i.test(value);
}, "Letters or punctuation only please");

$.validator.addMethod("dateformat", function(value, element) {
    return this.optional(element) || /^\d\d?\/\d\d?\/\d\d\d\d$/.test(value);
}, "Please enter a date in the format dd/mm/yyyy");

$.validator.addMethod("lettersonly", function(value, element) {
    return this.optional(element) || /^[a-z\-\s]+$/i.test(value);
}, "Please enter letters only please");